<form>
  <sd-border-wrapper class="has-no-padding">
    <div class="c__header">
      <sd-title [titleLevel]="titleLevel" customClass="brand--h5 is-regular">
        {{ 'order.return.orderReturn' | translate }}
      </sd-title>
    </div>

    @for (product of orderProducts; track product) {
      <sd-order-return-detail
        #productReturn
        [returnListConfig]="returnListConfig"
        [product]="product"
        [readonly]="canReturnProduct"
        (selectedProduct)="updateProductList($event)"
        (deselectedProduct)="deselectProduct($event)"
        (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
      />
    }

    <div class="c__actions is-first-step">
      <button sd-button
        type="button"
        [disabled]="productsSelected.length === 0 || canReturnProduct"
        (click)="returnProduct()"
      >
        <span>{{ "actions.validate" | translate }}</span>
      </button>
    </div>

    @if (canReturnProduct) {
      <div class="c__header">
        <sd-title [titleLevel]="titleLevel" customClass="brand--h5 is-regular">
          {{ 'order.return.ticket' | translate }}
        </sd-title>
      </div>
      <div class="c__content">
        <p>{{ 'order.return.note' | translate }}</p>
        <div class="c__actions">
          <button sd-button type="button" (click)="printReturnDetails()">
            <span>{{ "order.return.printDetails" | translate }}</span>
          </button>
          <button sd-button type="button" (click)="printReturnTicket()">
            <span>{{ "order.return.printTicket" | translate }}</span>
          </button>
        </div>
      </div>
    }
  </sd-border-wrapper>
</form>
